<template>
    <div class="project-menu-container">
        <ToolButton 
            v-if="fs.show('Project.Select')" 
            :disabled="fs.disabled('Project.Select')" 
            :icon="this.$modalDlg.state.visNav?'close':'source'" 
            title="message.project_select" 
            v-on:click="toggleVis"
            style="position: relative; height: 100%; width: 92px; height: 30px;"
            btnStyle="position: absolute; top:0; left: -12px; width:110px"
            primary/>

        <div v-if="!type && globalState.curFolderName && (
            (fs.show('Project.Definition.View') && globalState.projType !== 'BkdTmpl')
            || fs.show('Project.Catalogues.View')
            || fs.show('Project.Issues.View')
            || fs.show('Comparison.View')
            || fs.show('Project.Baseline.View')
            || (globalState.blockChainReady && fs.show('Blockchain.View'))
        )" style="display: flex; gap:2px;align-items: center;">
            <ToolButton 
                v-if="fs.show('Project.Definition.View') && globalState.projType !== 'BkdTmpl'"
                :disabled="fs.disabled('Project.Definition.View')"
                icon="settings" 
                v-on:click="openProps" 
                subprimary 
                tool-tip="message.prop_btn"/>

            <v-menu offset-y v-if="fs.show('Project.Catalogues.View')
                    && globalState.projType !== 'BkdTmpl'">
                <template v-slot:activator="{ on: onMenu }">
                    <ToolButton v-on="{ ...onMenu}"
                        :disabled="fs.disabled('Project.Catalogues.View')"
                        icon="receipt" 
                        subprimary 
                        title="message.catalog_btn" 
                        tool-tip="message.catalog_btn"/>
                </template>
                <v-list dense>
                <v-list-item
                    v-if="fs.show('Project.Catalogues.Organizations.View')"
                    :disabled="fs.disabled('Project.Catalogues.Organizations.View')"
                     :key="1" 
                     @click="openOrgs()">
                    <v-list-item-title>{{ $t( 'message.menu_catalog_org' ) }}</v-list-item-title>
                </v-list-item>
                <v-list-item 
                    v-if="fs.show('Project.Catalogues.Products.View')"
                    :disabled="fs.disabled('Project.Catalogues.Products.View')"
                    :key="2" 
                    @click="openProds()">
                    <v-list-item-title>{{ $t( 'message.menu_catalog_prod' ) }}</v-list-item-title>
                </v-list-item>
                <v-list-item 
                    v-if="fs.show('Project.Catalogues.Actions.View')"
                    :disabled="fs.disabled('Project.Catalogues.Actions.View')"
                    :key="3" 
                    @click="openActions()">
                    <v-list-item-title>{{ $t( 'message.menu_catalog_act' ) }}</v-list-item-title>
                </v-list-item>
                <v-list-item 
                    v-if="fs.show('Project.Catalogues.Triggers.View')"
                    :disabled="fs.disabled('Project.Catalogues.Triggers.View')"
                    :key="4" 
                    @click="openTriggers()">
                    <v-list-item-title>{{ $t( 'message.menu_catalog_trg' ) }}</v-list-item-title>
                </v-list-item>
                <v-list-item 
                    v-if="fs.show('Project.Catalogues.NotificatinTasks.View')"
                    :disabled="fs.disabled('Project.Catalogues.NotificatinTasks.View')"
                    :key="5" 
                    @click="openNTasks()">
                    <v-list-item-title>{{ $t( 'message.menu_catalog_ntask' ) }}</v-list-item-title>
                </v-list-item>
                </v-list>
            </v-menu>
            
            <ToolButton 
                v-if="fs.show('Project.Issues.View')" 
                :disabled="fs.disabled('Project.Issues.View')"
                icon="task"
                title="message.issue_list_btn"
                tool-tip="message.issue_list_btn_tooltip"
                v-on:click="openIssueList"
                subprimary/>
            <ToolButton 
                v-if="fs.show('Comparison.View')" 
                :disabled="fs.disabled('Comparison.View')"
                icon="compare" 
                title="message.diff_btn" 
                tool-tip="message.diff_btn_tooltip" 
                v-on:click="openDiff"
                subprimary/>
            <ToolButton
                v-if="fs.show('Project.Baseline.View')" 
                :disabled="fs.disabled('Project.Baseline.View')" 
                icon="offline_pin" 
                tool-tip="message.baseline_list_btn" 
                v-on:click="openBaselines"
                subprimary/>
            <ToolButton 
                v-if="globalState.blockChainReady && fs.show('Blockchain.View')" 
                :disabled="fs.disabled('Blockchain.View')" 
                icon="share" 
                tool-tip="message.open_chain" 
                v-on:click="openChain" 
                subprimary/>
        </div>

        <ToolButton v-if="!!type && globalState.curFolderName" icon="reply" tool-tip="message.to_proj_btn" v-on:click="backToProj" subprimary/>

        <v-menu offset-y v-if="!type && globalState.curFolderName && fs.show('Search')">
          <template v-slot:activator="{ on: onMenu }">
            <ToolButton 
                v-if="fs.show('Search')" 
                :disabled="fs.disabled('Search')"
                v-on="{ ...onMenu}" 
                icon="search" 
                circle 
                light/>
          </template>
          <v-list dense>
            <v-list-item :key="1" @click="quickSearch()" v-if="fs.show('Search.QuickNode')" :disabled="fs.disabled('Search.QuickNode')">
              <v-list-item-title>{{ $t( 'message.menu_search_quick' ) }}</v-list-item-title>
            </v-list-item>
            <v-list-item :key="2" @click="nodeSearch()" v-if="fs.show('Search.Node')" :disabled="fs.disabled('Search.Node')">
              <v-list-item-title>{{ $t( 'message.menu_search_node' ) }}</v-list-item-title>
            </v-list-item>
            <v-list-item :key="3" @click="docQuickSearch()" v-if="fs.show('Search.QuickDoc')" :disabled="fs.disabled('Search.QuickDoc')">
              <v-list-item-title>{{ $t( 'message.menu_search_doc_quick' ) }}</v-list-item-title>
            </v-list-item>
            <v-list-item :key="4" @click="docSearch()" v-if="fs.show('Search.Doc')" :disabled="fs.disabled('Search.Doc')">
              <v-list-item-title>{{ $t( 'message.menu_search_doc' ) }}</v-list-item-title>
            </v-list-item>
            <v-list-item :key="5" @click="docTxtSearch()" v-if="fs.show('Search.DocByContent')" :disabled="fs.disabled('Search.DocByContent')">
              <v-list-item-title>{{ $t( 'message.menu_search_doc_txt' ) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <BreadcrumbsLine v-if="fs.show('Breadcrumps')"/>
        <v-menu offset-y v-if="fs.show('LanguageSwitch2')">
          <template v-slot:activator="{ on }">
            <v-btn small fab text v-on="on" id="toolbarLang"  :disabled="fs.disabled('LanguageSwitch2')">{{langInfo.locale}}</v-btn>
          </template>
          <v-list dense>
              <v-list-item v-for="l in langs" :key="l" @click="()=>$i18n.locale = l">
              <v-list-item-title>{{ l }}</v-list-item-title>
              </v-list-item>
          </v-list>
        </v-menu>
        <ToolButton 
          ghost
          v-if="fs.show('Help2')" 
          :disabled="fs.disabled('Help2')" 
          icon="help" 
          v-on:click="()=>this.$utils.openHelp('')" 
          tool-tip="message.help_btn"/>
    </div>
</template>

<script>
import ToolButton from './ToolButton.vue';
import BreadcrumbsLine from './BreadcrumbsLine.vue';
import router from '@/router';
import{ conf } from '@/utils/confTruePLM';
import FeaturesSet from "@/utils/features"

export default {
    components:{
        ToolButton: ToolButton,
        BreadcrumbsLine: BreadcrumbsLine,
    },
    props: {
        type: {
            type: String,
            default: null
        }
    },
    computed: {
      langs() {
        return Object.keys( this.$i18n.messages );
      }
    },

    data() {
        return {
            fs: FeaturesSet,
            globalState: this.$globalStore.state,
            langInfo: this.$i18n,
        }
    },

    watch: {

    },

    mounted() {
        this.$eventBus.$on( 'procIssueRowMenuCmd', ( info ) => {
            this.procIssueRowMenuCmd( info );
        });
    },
    beforeDestroy: function(){
        this.$eventBus.$off( 'procIssueRowMenuCmd' );
    },

    methods: {
        toggleVis() {
            this.$modalDlg.toggleNav();
        },
        openProps(){
            router.push( '/props' );
        },
        openIssueList() {
            this.$modalDlg.sysDlgs.issueListDlg.open();
        },
        openChain() {
            let proj = conf.getProj();
            let url = '#/chain?';
            window.open( url + 'rep=' + proj.repository + '&model=' + proj.in_project.project_model_id + '&role=' + proj.userType, '_blank' );        
        },
        backToProj() {
            router.push( '/home' );
        },
        openOrgs(){
            router.push( '/orgs' );
        },
        openProds(){
            router.push( '/prods' );
        },
        openNTasks(){
            router.push( '/ntasks' );
        },
        openTriggers(){
            router.push( '/triggers' );
        },
        openActions(){
            router.push( '/actions' );
        },
        openBaselines(){
            var self = this;
            self.$modalDlg.sysDlgs.baselineListDlg.open()
                    .then( ( bsl ) =>
            {
                if( bsl )
                    self.$eventBus.$emit( 'openBaseline', bsl );
            });
        },
        openDiff(){
            var self = this;
            self.$modalDlg.sysDlgs.makeDiffDlg.open()
                    .then( ( info ) =>
            {
                let proj = conf.getProj();
                
                let url = '#/diff?';
                
                let obj1 = info.ver1 ? info.ver1 : info.base1;
                let obj2 = info.ver2 ? info.ver2 : info.base2;
                
                if( obj1.bkd_ver > obj2.bkd_ver )
                {
                    obj2 = info.ver1 ? info.ver1 : info.base1;
                    obj1 = info.ver2 ? info.ver2 : info.base2;
                }
                
                if( obj1.is_baseline )
                    url += 'base1=' + obj1.ver + '&ver1=' + obj1.bkd_ver;
                else
                    url += 'ver1=' + obj1.ver;
                
                if( obj2.is_baseline )
                    url += '&base2=' + obj2.ver + '&ver2=' + obj2.bkd_ver;
                else
                    url += '&ver2=' + obj2.ver;
                
                window.open( url + '&rep=' + proj.repository + '&model=' + proj.in_project.project_model_id + '&role=' + proj.userType, '_blank' );
            }, () => {});
        },
        nodeSearch(){
            var self = this;
            self.$modalDlg.sysDlgs.searchNodeDlg.open()
                    .then( ( info ) =>
            {
                self.$eventBus.$emit( 'searchNode', info );
            }, () => {} );
        },
        quickSearch(){
            let self = this;
            this.$modalDlg.sysDlgs.qSearchNodeDlg.open()
                    .then( ( info ) =>
            {
                self.$eventBus.$emit( 'searchQuick', info );
            }, () => {} );
        },
        docQuickSearch(){
            let self = this;
            this.$modalDlg.sysDlgs.qSearchNodeDlg.open( true )
                    .then( ( info ) =>
            {
                self.$eventBus.$emit( 'searchDocQuick', info );
            }, () => {} );
        },
        docTxtSearch(){
            let self = this;
            this.$modalDlg.sysDlgs.txtSearchDocDlg.open().then( ( info ) => {
                self.$eventBus.$emit( 'searchDocTxt', info );
            }, () => {} );
        },
        docSearch(){
            var self = this;
            self.$modalDlg.sysDlgs.searchDocDlg.open().then( ( info ) => {
                self.$eventBus.$emit( 'searchDoc', info );
            }).catch( () => {} );
        },

        procIssueRowMenuCmd( info ) {
            if( info.cmd === 'openIssue' )
                this.openIssue( info.data );
            else if( info.cmd === 'openSubj' )
                this.openSubj( info.data );
            else if( info.cmd === 'addIssue' )
                this.addIssue( info.data.subj, info.data.prn, info.data.domain );
        },
        addIssue( subj, prn, domain ){
            let self = this;
            let newDt = {};

            if( !domain && prn )
            {
                    let ind = prn.id.lastIndexOf( '-' );
                    if( ind > 0 )
                        domain = prn.id.substring( 0, ind );
            }

            self.$modalDlg.sysDlgs.addIssueDlg.open( { subj: subj, masterID: prn ? prn.plcs_id : null, domain: domain } )
                    .then( data =>
            {
                newDt = data;
                return conf.addIssue( data );
            }, () => {} )
                    .then( issue =>
            {
                if( issue )
                {
                    let func = [];
                    if( subj )
                            func.push( conf.addIssueSubject( issue.plcs_id, subj.instance_id ) );
                    if( newDt.datetime_IssueDeadline )
                            func.push( conf.setIssueTime( issue.plcs_id, newDt.datetime_IssueDeadline, 
                                                'urn:plcs:rdl:TruePLM:IssueDeadline' ) );                       
                    
                    for( let key in newDt.personsList )
                            func.push( conf.setIssuePersonList( issue.plcs_id, newDt.personsList[ key ], key ) );

                    return Promise.all( func );
                }
            })
                    .then( issue => 
            {
                if( issue ) 
                    self.$modalDlg.sysDlgs.confirmDlg.openOkOnly( 'add_issue_title', 'add_issue_msg' );
            })
                    .catch( ( err ) =>
            {
                self.$eventBus.$emit( 'queryError', err );
            });
        },
        openSubj( info ){
            this.$eventBus.$emit( 'procRowMenuCmd', [ 'gotoNode', info.subjects[ 0 ].path_id ] );  
        },
        openIssue( info ) {
            let self = this;
            //let edit = false;
            self.$modalDlg.sysDlgs.addIssueDlg.open( info )
                    .then( data =>
            {
                let func = [];
                if( data.plcs_id === info.plcs_id )
                {
                    if( data.master !== info.masterID )
                        func.push( conf.addIssueChild( data.master, info.plcs_id ) );

                    if( data.status !== info.status )
                        func.push( conf.setIssueClass( info.plcs_id, 'urn:plcs:rdl:TruePLM:IssueStatus', data.status ) );
                    
                    if( data.priority !== info.priority )
                        func.push( conf.setIssueClass( info.plcs_id, 'urn:plcs:rdl:TruePLM:IssuePriority', data.priority ) );
                    
                    if( data.issue_type !== info.issue_type )
                        func.push( conf.setIssueClass( info.plcs_id, 'urn:plcs:rdl:TruePLM:GenericIssue', data.issue_type ) );
                    
                    if( data.name !== info.name )
                        func.push( conf.setIssueID( info.plcs_id, 'urn:plcs:rdl:TruePLM:IssueName', data.name ) );

                    if( data.description !== info.description )
                        func.push( conf.setIssueDescr( info.plcs_id, data.description ) );

                    if( info.responsible )
                            info.persons.push( { role_urn: 'urn:plcs:rdl:TruePLM:Responsible', person: info.responsible } );

                    let checkMap = {};
                    let writePersons = this.$utils.isEmpty( info.persons );
                    if( !writePersons )  
                    {
                            info.persons.forEach( p =>
                            {
                                let uList = data.personsList[ p.role_urn ];
                                if( !uList )
                                {
                                    data.personsList[ p.role_urn ] = '';
                                    writePersons = true;
                                }
                                else
                                {
                                    if( uList !== '' )
                                    {
                                        if( !uList.includes( p.person ) )
                                            writePersons = true;
                                        else
                                            checkMap[ p.role_urn ] = ( checkMap[ p.role_urn ] || 0 ) + 1;
                                    }
                                }
                            });
                    } 

                    if( !writePersons )
                    {
                            for( let key in data.personsList )
                            {
                                if( !( ( key === 'urn:plcs:rdl:TruePLM:Responsible' && checkMap[ key ] === 1 ) 
                                        || data.personsList[ key ].length === checkMap[ key ] ) )
                                    writePersons = true;
                            }
                    }

                    if( writePersons )
                    {
                            for( let key in data.personsList )
                                    func.push( conf.setIssuePersonList( info.plcs_id, data.personsList[ key ], key ) );
                    }
                    
                    if( data.datetime_IssueDeadline !== info.datetime_IssueDeadline )
                        func.push( conf.setIssueTime( info.plcs_id, data.datetime_IssueDeadline, 'urn:plcs:rdl:TruePLM:IssueDeadline' ) ); 
                }
                
                return Promise.all( func );
            }, () => {} )
                    .then( rez =>
            {
                if( rez && rez.length > 0 )
                    self.$modalDlg.sysDlgs.confirmDlg.open( 'edit_issue_title', 'edit_issue_msg', info.id, null, true );
            } )
                    .catch( ( err ) =>
            {
                self.$eventBus.$emit( 'queryError', err );
            });
        }
    }
}
</script>

<style scoped>
    .project-menu-container{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 8px;
        gap: 8px;
    }
</style>